import React, { useEffect, useState } from "react";

// js
import { changeHeaderBackGround } from "../js/main";

// action
import { loginRegister } from "../store/user/action";
// redux
import { connect } from "react-redux";

// validation
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";


const Login = (props) => {
    useEffect(() => {
        changeHeaderBackGround();
    }, []);

    // form validation rules
    const validationSchema = Yup.object().shape({
        username: Yup.string().trim().required("Username is Required!"),
        password: Yup.string().trim().required("Password is Required!"),
    });

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({ resolver: yupResolver(validationSchema) });

    const onSubmit = (values) => {
        props.loginRegister({ type: "login", data: values });
    };


    return (
        <main id="main">
            <section>
                <h1 className="text-center my-5">Login</h1>
                <div className="container">
                    <div className="row">
                        <div className="col-3"></div>
                        <div className="col-md-6 col-sm-12">
                            <form className="form" onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                                <div className="form-group mt-3 mt-md-0">
                                    <label for="username" className="small font-weight-bold text-warning">
                                        Username
                                    </label>
                                    <input
                                        type="text"
                                        name="username"
                                        className={`form-control ${errors.username ? "is-invalid" : ""}`}
                                        id="username"
                                        placeholder="Enter Your Username"
                                        required
                                        {...register("username")}
                                    />
                                    <div className="invalid-feedback">
                                        {errors.username?.message}
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label for="password" className="small font-weight-bold text-warning">
                                        Password
                                    </label>
                                    <input
                                        type="password"
                                        className={`form-control ${errors.password ? "is-invalid" : ""}`}
                                        name="password"
                                        id="password"
                                        placeholder="Enter Your Password"
                                        required
                                        {...register("password")}
                                    />
                                    <div className="invalid-feedback">{errors.password?.message}</div>
                                </div>


                                <div className="text-center"><button type="submit">Submit</button></div>
                            </form>
                        </div>
                        <div className="col-3"></div>

                    </div>
                </div>
            </section>
        </main >
    )
}

export default connect(null, { loginRegister })(Login);